import { h, Component } from 'preact';
import SectionBackground from 'components/bolt/sectionBackground/sectionBackground';
import AgeGate from 'components/bolt/ageGate/ageGate';
import s from 'components/bolt/section/section.sss';
import Store from 'store/store';

export default class Section extends Component {
	renderBgContent() {
		const { appData, id } = this.props;
		const pageData = appData.pages[id]?.data;

		return (
			<div class={s.contentBelow}>
				{!!pageData?.bg && <SectionBackground ref={ref => this.sectionBackground = ref} data={pageData.bg} />}
			</div>
		);
	}

	renderOverlayedContent() {
		const { appData, id } = this.props;
		const { ageGateOpen } = Store.get();
		let showAgeGate;

		const isSection = appData.pages[id]?.section;
		const ageGateEnabled = appData.options.ageGate;

		if (ageGateEnabled) {
			const ageGateOnlyOnPages = ageGateEnabled?.onlyOnPages || '';
			const hasAgeGate = ageGateOnlyOnPages.split(',').map(e => e.trim()).includes(id) && isSection;
			showAgeGate = hasAgeGate && (ageGateOpen !== false);
		}

		if (!showAgeGate) {
			return;
		}

		return (
			<div class={s.overlayedContent}>
				{showAgeGate && <AgeGate appData={appData} copy={appData.copy} key="ageGate" isSectionAgeGate />}
			</div>
		);
	}
}